import React from 'react';

const IconGitLab = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-gitlab">
      <title>GitLab</title>
      <path d="M22.5 9.8l-1.2-3.6c-.3-.8-1.5-.8-1.8 0l-1.7 5.3H6.2L4.5 6.2c-.3-.8-1.5-.8-1.8 0L1.5 9.8c-.2.6 0 1.3.5 1.7L12 22l10-10.5c.5-.4.7-1.1.5-1.7z"></path>
   </svg>
);

export default IconGitLab;